(function initScrollBasedMenuHandler() {
  'use strict';

  //Ejecutar página principal
  if (window.location.pathname !== '/') {
    console.debug('[Menu Debug] Página no es home. Script abortado.');
    return;
  }

  const navSelector = 'div.position-lg-relative.d-lg-flex.w-100 > nav.menu.menu--main.menu--vertical.position-lg-absolute.w-100.py-25.py-lg-0.px-lg-20.top-lg-100.left-lg-0.js-vertical-menu.js-position.menu--loaded';
  const headerSelector = '#header';
  const CONTROL_ATTR = 'data-scroll-controlled';
  const VISIBILITY_THRESHOLD = -207;

  let lastState = null;

  function getElements() {
    return {
      nav: document.querySelector(navSelector),
      header: document.querySelector(headerSelector),
      sentinel: document.querySelector('#header-sentinel'),
    };
  }

  function insertSentinel(header) {
    if (document.querySelector('#header-sentinel')) return;

    const sentinel = document.createElement('div');
    sentinel.id = 'header-sentinel';
    sentinel.style.cssText = 'height: 1px; width: 100%;';
    header.parentNode.insertBefore(sentinel, header);
    console.debug('[Menu Debug] Sentinel insertado antes del encabezado');
  }

  function applyState(nav, isVisible) {
    if (isVisible) {
      nav.classList.add('menu--open', 'menu--fixed');
      nav.setAttribute(CONTROL_ATTR, 'true');
      console.debug('[Menu Debug] Estado: visible → clases aplicadas');
    } else {
      nav.classList.remove('menu--open', 'menu--fixed');
      nav.removeAttribute(CONTROL_ATTR);
      console.debug('[Menu Debug] Estado: oculto → clases removidas');
    }
  }

  function updateMenuState() {
    const { nav, sentinel } = getElements();
    if (!nav || !sentinel) return;

    const top = sentinel.getBoundingClientRect().top;
    const isVisible = top <= 0 && top >= VISIBILITY_THRESHOLD;

    // console.debug('Debug guia sentinel.top:', top);
    // console.debug('Debug guia Estado actual:', isVisible ? 'visible' : 'oculto');

    const currentState = isVisible ? 'visible' : 'hidden';
    if (currentState === lastState) return;

    lastState = currentState;
    applyState(nav, isVisible);
  }

  function monitorExternalChanges() {
    const { nav } = getElements();
    if (!nav) return;

    const observer = new MutationObserver(() => {
      if (nav.getAttribute(CONTROL_ATTR) === 'true') {
        if (!nav.classList.contains('menu--open') || !nav.classList.contains('menu--fixed')) {
        //   console.debug('DEBIG - Reaplicando clases por interferencia externa');
          nav.classList.add('menu--open', 'menu--fixed');
        }
      }
    });

    observer.observe(nav, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function init() {
    const { nav, header } = getElements();
    if (!nav || !header) {
    //   console.warn('DEBUG - Elementos no encontrados.');
      return;
    }

    insertSentinel(header);
    updateMenuState();
    monitorExternalChanges();

    window.addEventListener('scroll', () => {
      requestAnimationFrame(updateMenuState);
    });
  }

  const observer = new MutationObserver(() => {
    const { nav, header } = getElements();
    if (nav && header) {
      init();
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();


// ****

(function () {
  'use strict';

    if (window.location.pathname !== '/') {
    // console.debug('DEBUG Página no home Script abortado');
    return;
  }
  const SELECTOR_PANEL = 'nav.menu.menu--main .menu__panel';
  const SELECTOR_ITEM = '.menu__item';
  const VISIBLE_LIMIT = 11;

  function revealMenuItems() {
    const panel = document.querySelector(SELECTOR_PANEL);
    if (!panel) {
    //   console.warn('DEBUG Panel no encontrado.');
      return;
    }

    const items = panel.querySelectorAll(SELECTOR_ITEM);
    // console.debug(`[MenuReveal] ${items.length} items encontrados.`);

    items.forEach((item, index) => {
      if (index < VISIBLE_LIMIT) {
        item.removeAttribute('data-js-menu-vertical-item');
        item.removeAttribute('aria-hidden');
        item.classList.remove('hidden');
        item.style.setProperty('display', 'block', 'important');
        // console.debug(`[MenuReveal] Item ${index + 1} limpiado y forzado a visible.`);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealMenuItems);
  } else {
    revealMenuItems();
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      [...mutation.addedNodes].forEach((node) => {
        if (node.nodeType === 1 && node.matches?.(SELECTOR_PANEL)) {
        //   console.warn('Panel inyectado dinámicamente.');
          revealMenuItems();
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();